import { combineReducers } from 'redux-loop';
import { intlReducer } from 'react-intl-redux';
import { scans } from './scans';

export default (history) => combineReducers({
  intl: intlReducer,
  scans,
});
